import { DEFAULT_VARIANT, Icon } from "../Icon.js";
import { jsx } from "react/jsx-runtime";
import { useTranslation } from "react-i18next";

//#region src/components/icon/variants/IconLogout.tsx
const OutlinedFilledLogout = (props) => /* @__PURE__ */ jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 -960 960 960",
	...props,
	children: /* @__PURE__ */ jsx("path", { d: "M189-95q-39.05 0-66.53-27.47Q95-149.95 95-189v-582q0-39.46 27.47-67.23Q149.95-866 189-866h296v95H189v582h296v94H189Zm467-174-67-66 97-98H354v-94h330l-97-98 67-66 212 212-210 210Z" })
});
const OutlinedLogout = (props) => /* @__PURE__ */ jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 -960 960 960",
	...props,
	children: /* @__PURE__ */ jsx("path", { d: "M189-95q-39.05 0-66.53-27.47Q95-149.95 95-189v-582q0-39.46 27.47-67.23Q149.95-866 189-866h296v95H189v582h296v94H189Zm467-174-67-66 97-98H354v-94h330l-97-98 67-66 212 212-210 210Z" })
});
const RoundedFilledLogout = (props) => /* @__PURE__ */ jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 -960 960 960",
	...props,
	children: /* @__PURE__ */ jsx("path", { d: "M189-95q-39.05 0-66.53-27.47Q95-149.95 95-189v-582q0-39.46 27.47-67.23Q149.95-866 189-866h249q19.75 0 33.38 14.26 13.62 14.27 13.62 34 0 19.74-13.62 33.24Q457.75-771 438-771H189v582h249q19.75 0 33.38 13.68Q485-161.65 485-141.82q0 19.82-13.62 33.32Q457.75-95 438-95H189Zm497-338H401q-19.75 0-33.37-13.68Q354-460.35 354-480.18q0-19.82 13.63-33.32Q381.25-527 401-527h283l-64-64q-14-14.21-13.5-33.6.5-19.4 14.5-32.9 14-14.5 33.15-14T688-657l145 145q13 14.36 13 33.18T833-446L689-302q-13.8 14-32.9 14-19.1 0-33.49-14-13.61-14-14.15-33.38-.54-19.37 14.54-33.62l63-64Z" })
});
const RoundedLogout = (props) => /* @__PURE__ */ jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 -960 960 960",
	...props,
	children: /* @__PURE__ */ jsx("path", { d: "M189-95q-39.05 0-66.53-27.47Q95-149.95 95-189v-582q0-39.46 27.47-67.23Q149.95-866 189-866h249q19.75 0 33.38 14.26 13.62 14.27 13.62 34 0 19.74-13.62 33.24Q457.75-771 438-771H189v582h249q19.75 0 33.38 13.68Q485-161.65 485-141.82q0 19.82-13.62 33.32Q457.75-95 438-95H189Zm497-338H401q-19.75 0-33.37-13.68Q354-460.35 354-480.18q0-19.82 13.63-33.32Q381.25-527 401-527h283l-64-64q-14-14.21-13.5-33.6.5-19.4 14.5-32.9 14-14.5 33.15-14T688-657l145 145q13 14.36 13 33.18T833-446L689-302q-13.8 14-32.9 14-19.1 0-33.49-14-13.61-14-14.15-33.38-.54-19.37 14.54-33.62l63-64Z" })
});
const SharpFilledLogout = (props) => /* @__PURE__ */ jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 -960 960 960",
	...props,
	children: /* @__PURE__ */ jsx("path", { d: "M95-95v-771h390v95H189v582h296v94H95Zm561-174-67-66 97-98H354v-94h330l-97-98 67-66 212 212-210 210Z" })
});
const SharpLogout = (props) => /* @__PURE__ */ jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 -960 960 960",
	...props,
	children: /* @__PURE__ */ jsx("path", { d: "M95-95v-771h390v95H189v582h296v94H95Zm561-174-67-66 97-98H354v-94h330l-97-98 67-66 212 212-210 210Z" })
});
const componentMap = {
	outlined: OutlinedLogout,
	"outlined-fill": OutlinedFilledLogout,
	rounded: RoundedLogout,
	"rounded-fill": RoundedFilledLogout,
	sharp: SharpLogout,
	"sharp-fill": SharpFilledLogout
};
const IconLogout = ({ color, filled, height, variant = "rounded", style = {}, width, "data-testid": testId }) => {
	const { t } = useTranslation("pds");
	return /* @__PURE__ */ jsx(Icon, {
		SvgIcon: componentMap[`${variant}${filled ? "-fill" : ""}`] ?? componentMap[DEFAULT_VARIANT],
		alt: t(""),
		"data-testid": testId,
		color,
		style,
		height,
		width
	});
};

//#endregion
export { IconLogout };